import Roles from '@/auth/roles';
import i18n from '@/lang' // Internationalization
import historyFullStore from './category-history/category-history-full/category-history-full-store';
import historySingleStore from './category-history/category-history-single/category-history-single-store';
import categoryModel from './category-model';
import categoryPager from './category-pager';
import service from './category-service';
/* eslint-disable */
export default {
  namespaced: true,

  modules: {
    historyFull: historyFullStore,
    historySingle: historySingleStore
  },

  state: {
    loading: false,
    list: [],
    pager: categoryPager.build(),
    model: categoryModel.default(),
  },

  getters: {
    loading: state => state.loading,
    list: state => state.list,
    pager: (state) => state.pager,
    model: state => state.model,
    hasRoleToUpdate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.categoryEditor.id
      ]);
    },
    hasRoleToCreate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.categoryEditor.id
      ]);
    },
    hasRoleToRead: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.categoryViewer.id,
        roles.categoryEditor.id
      ]);
    },
    hasRoleToReadLogs: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    },
    hasRoleToDelete: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.categoryEditor.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload || categoryModel.default();
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = categoryPager.build();
      state.model = categoryModel.default();
    },
  },

  actions: {
    detail({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service.find(id).then((model) => {
        if (!model || !model.id) {
          return Promise.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return Promise.resolve();
      }).catch((error) => {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },

    new({ commit }) {
      commit('MODEL', null);
    },

    edit({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service.find(id).then((model) => {
        if (!model || !model.id) {
          return Promise.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return Promise.resolve();
      }).catch((error) => {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },

    save({ getters, commit, rootGetters, dispatch }, model) {
      commit('LOADING', true);

      var modelToSave = getters.model

      if (model !== null ) {
        modelToSave = model
      } 

      
      return service
        .save(modelToSave, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.category.singular')} ${i18n.t('notification.savedSuccessfully')}`,
            { root: true }
          );

          commit('LOADING', false);
        }).catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    destroy({ commit, dispatch, rootGetters }, id) {
      commit('LOADING', true);

      return service
        .destroy(id, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.category.singular')} ${i18n.t('notification.deletedSuccessfully')}`,
            { root: true }
          );
        })
        .then(() => dispatch('list'))
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    list({ commit, dispatch }) {
      commit('LIST', []);
      commit('LOADING', true);

      return service
        .list()
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    clear({ commit }) {
      commit('CLEAR');
    },
  },
};



// WEBPACK FOOTER //
// ./src/entities/category/category-store.js